// extracted by mini-css-extract-plugin
export var border = "_8o-0";
export var borderSelected = "_8o-1";
export var check = "_8o-6";
export var circle = "_8o-2";
export var circleInner = "_8o-4";
export var circleInnerDisabled = "_8o-8";
export var description = "_8o-3";
export var horizontal = "_8o-b";
export var input = "_8o-5";
export var label = "_8o-9";
export var radioButton = "_8o-d";
export var radioButtonNoCenter = "_8o-e";
export var radioGroup = "_8o-a";
export var rightRadio = "_8o-f";
export var subcontent = "_8o-g";
export var uncheck = "_8o-7";
export var vertical = "_8o-c";